export const STATUS_LOADING = "loading";
export const STATUS_SUCCESS = "success";
export const STATUS_FAILURE = "failure";
